module.exports = __webpack_public_path__ + "static/img/合照2.1068140.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/hezhao/合照2.jpg
// module id = XTh1
// module chunks = 1